<template>
  <v-dialog persistent v-model="openProfileDialog" max-width="700">
    <v-card>
      <v-card-title class="heading">
        <v-row no-gutters>
          <v-col cols="6">
            <span
              class="text-h6 font-weight-bold text-uppercase text_color--text"
            >
              profile
            </span>
            <v-spacer></v-spacer>
          </v-col>
          <v-col cols="6 d-flex justify-end">
            <v-icon @click="closeForm" color="text_color--text">
              mdi-close
            </v-icon>
          </v-col>
          <v-col cols="12" v-if="nonFieldError.length">
            <v-alert dense type="error">
              <v-list
                class="pa-0"
                dense
                style="background: inherit !important"
                v-for="(error, i) in nonFieldError"
                :key="i"
              >
                <v-list-item dense style="min-height: 20px !important">
                  <span>{{ i }} . </span><span>{{ error }}</span>
                </v-list-item>
              </v-list>
            </v-alert>
          </v-col>
        </v-row>
      </v-card-title>

      <v-row no-gutters class="px-6">
        <v-col cols="3" class="pt-4">
          <ProfileUpload
            v-model="profileImage"
            @UploadProfile="updateProfile"
            imageHeight="140px"
          />
        </v-col>
        <v-col cols="1"> </v-col>
        <v-col cols="8">
          <v-form v-model="isValid" @submit.prevent="">
            <v-row class="ma-0 py-0">
              <v-col cols="12">
                <InputField
                  name="username"
                  :required="true"
                  label="Username"
                  :error-messages="formErrors.username"
                  v-model="userDetails.username"
                  @input="delete formErrors.username"
                ></InputField>
              </v-col>
              <v-col cols="6">
                <InputField
                  name="first_name"
                  :required="true"
                  label="First Name"
                  :rules="[
                    (v) =>
                      !/[^a-zA-Z0-9 ]/.test(v) ||
                      `Special characters are not allowed`,
                  ]"
                  :error-messages="formErrors.first_name"
                  v-model="userDetails.first_name"
                  @input="delete formErrors.first_name"
                ></InputField>
              </v-col>
              <v-col cols="6" class="pt-4">
                <InputField
                  label="Last Name"
                  name="last_name"
                  :required="true"
                  :rules="[
                    (v) =>
                      !/[^a-zA-Z0-9 ]/.test(v) ||
                      `Special characters are not allowed`,
                  ]"
                  :error-messages="formErrors.last_name"
                  v-model="userDetails.last_name"
                  @input="delete formErrors.last_name"
                ></InputField>
              </v-col>
              <v-col cols="12" class="pt-4">
                <InputField
                  min="0"
                  step="01"
                  name="contact_number"
                  label="Contact number"
                  :required="true"
                  :rules="[
                    (v) =>
                      !/[^0-9]/.test(v) || `Only numeric values are allowed`,
                    (val) =>
                      (val && val.length >= 9 && val.length <= 12) ||
                      'Contact number should be between 9 to 12 digits!',
                  ]"
                  :error-messages="formErrors.contact_number"
                  v-model="userDetails.contact_number"
                  @input="delete formErrors.contact_number"
                ></InputField>
              </v-col>
              <v-col cols="12" class="pt-4">
                <InputField
                  outlined
                  label="Email"
                  name="email"
                  :required="true"
                  :rules="[
                    (value) => {
                      const pattern =
                        /^(([^<>()[\]\\.,;:\s@&quot;]+(\.[^<>()[\]\\.,;:\s@&quot;]+)*)|(&quot;.+&quot;))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                      return pattern.test(value) || `Invalid email id!`;
                    },
                  ]"
                  dense
                  :error-messages="formErrors.email"
                  v-model="userDetails.email"
                  @input="delete formErrors.email"
                ></InputField>
              </v-col>
              <v-col cols="12" class="d-flex justify-end">
                <v-btn
                  type="submit"
                  @click.prevent="submitUserDetails"
                  class="primary text-uppercase"
                  :disabled="!isValid"
                  depressed
                >
                  submit
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
import { bus } from "@/main";
import { generatedFormData } from "@/utils/functions";

export default {
  props: {
    value: Boolean,
  },
  data() {
    return {
      // userPermissions: this.$encrypt.getItem("permissions"),
      isValid: true,
      isEditMode: false,
      nonFieldError: [],
      profileImage: null,
      formErrors: {},
      userDetails: {},
    };
  },
  watch: {
    value(val) {
      if (val) {
        this.userDetails = { ...this.$helper.getUserDetailsLocalStorage() };
        if (this.userDetails && this.userDetails.profile_image) {
          this.profileImage = this.userDetails.profile_image;
          delete this.userDetails.profile_image;
        }
      }
    },
    isEditMode(val) {
      if (val) {
        let inter = setInterval(() => {
          if (this.$refs.profileForm) {
            clearInterval(inter);
            this.$refs.profileForm.validate();
          }
        });
      }
    },
  },
  computed: {
    openProfileDialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    closeForm() {
      this.openProfileDialog = false;
      this.profileImage = null;
      this.isEditMode = false;
    },
    updateProfile(image, isChangeable = false) {
      if (this.userDetails.update_profile_image || isChangeable) {
        this.userDetails.update_profile_image = true;
        if (image) {
          this.userDetails.profile_image = image;
        } else {
          delete this.userDetails.profile_image;
        }
      } else {
        this.userDetails.update_profile_image = false;
        delete this.userDetails.profile_image;
      }
    },
    onFileChanged(e) {
      const selectedFile = e.target.files[0];
      if (
        selectedFile.type.toLowerCase().indexOf("png") == -1 &&
        selectedFile.type.toLowerCase().indexOf("jpg") == -1 &&
        selectedFile.type.toLowerCase().indexOf("jpeg") == -1
      ) {
        alert("File type not supported \nSupported Types: PNG, JPG, JPEG");
        return null;
      }
      if (selectedFile) {
        const url = URL.createObjectURL(selectedFile);
        this.userDetails.update_profile_image = true;
        this.userDetails = {
          ...this.userDetails,
          profile_image: url,
        };
      }
    },
    submitUserDetails() {
      const form = document.getElementById("profileForm");
      let data = { ...this.userDetails };
      if (data && !data.update_profile_image) {
        delete data.profile_image;
      }

      bus.$emit("showLoader", true);
      this.$api.profile
        .updateProfile(generatedFormData(data))
        .then(() => {
          this.openProfileDialog = false;
          bus.$emit("showToastMessage", {
            message: "User Details Updated Successfully",
            color: "success",
          });
          setTimeout(() => {
            bus.$emit("showLoader", false);
            this.$emit("logout");
          }, 3000);
        })
        .catch((err) => {
          console.error(err);
          bus.$emit("showLoader", false);
          if ("non_field_errors" in err.data) {
            this.nonFieldError = err.non_field_errors;
          }
          this.formErrors = err.data;
          bus.$emit("showToastMessage", {
            message: "Couldn't update user details!",
            color: "error",
          });
        });
    },
  },
};
</script>
